export * from './IconDrillingPartRightStroked';
